import { render, staticRenderFns } from "./PaquetesForm.vue?vue&type=template&id=a22d9f82&scoped=true"
import script from "./PaquetesForm.vue?vue&type=script&lang=js"
export * from "./PaquetesForm.vue?vue&type=script&lang=js"
import style0 from "./PaquetesForm.vue?vue&type=style&index=0&id=a22d9f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22d9f82",
  null
  
)

export default component.exports